import React from "react";
import { motion } from "framer-motion";
import { useLang } from "../context/LanguageContext";

const groupAnim = (i) => ({
  initial: { opacity: 0, y: 30 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 1, delay: i * 0.15 },
});

function Group({ title, people, testid }) {
  return (
    <div
      className="flex flex-col items-center text-center gap-4"
      data-testid={testid}
    >
      <p className="text-xs uppercase tracking-[0.3em] text-burgundy">
        {title}
      </p>
      <div className="w-12 h-[1px] bg-warm-brown/60" />
      <div className="flex flex-col gap-1">
        {people.map((p) => (
          <p
            key={p}
            className="font-serif text-xl md:text-2xl text-ink leading-relaxed"
          >
            {p}
          </p>
        ))}
      </div>
    </div>
  );
}

export default function Family() {
  const { t } = useLang();

  const groupsTop = [
    {
      title: t.family.groomParents,
      people: ["Tudorel Bogdan", "Sanda Bogdan"],
      testid: "family-groom-parents",
    },
    {
      title: t.family.brideParents,
      people: ["Ioan Tomoiaga Rat", "Mariana Tomoiaga Rat"],
      testid: "family-bride-parents",
    },
  ];

  return (
    <section
      id="family"
      className="relative py-24 md:py-40 px-6 md:px-12 bg-cream/50"
      data-testid="family-section"
    >
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16 md:mb-24">
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.9 }}
            className="font-serif font-light text-3xl sm:text-4xl md:text-5xl text-ink"
          >
            {t.family.overline}
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 md:gap-24 mb-20">
          {groupsTop.map((g, i) => (
            <motion.div key={g.testid} {...groupAnim(i)}>
              <Group {...g} />
            </motion.div>
          ))}
        </div>

        <motion.div {...groupAnim(0)} className="flex justify-center">
          <Group
            title={t.family.witnesses}
            people={["Dorin Butilca", "Renata Butilca"]}
            testid="family-witnesses"
          />
        </motion.div>
      </div>
    </section>
  );
}
